import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20background%20with%20soft%20gradient%20curves%20in%20warm%20amber%20and%20cream%20tones%2C%20digital%20technology%20grid%20pattern%20subtly%20overlaid%2C%20clean%20modern%20aesthetic%2C%20geometric%20composition%20with%20flowing%20organic%20shapes%2C%20bright%20and%20airy%20atmosphere%2C%20no%20text&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="一级免费网站免费资源导航平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/50 via-background-950/30 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20">
        <div className="max-w-[900px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-background-50/20 backdrop-blur-sm rounded-full border border-background-50/20 mb-8">
            <i className="ri-sparkling-line text-primary-400 text-sm"></i>
            <span className="text-background-50/90 text-xs font-medium">
              精选 500+ 优质免费资源 · 每日更新
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight mb-6">
            发现最好的
            <span className="text-primary-300">免费资源</span>
            ，一站式
            <span className="text-accent-300">高效导航</span>
          </h1>

          <p className="text-background-200/90 text-sm md:text-base max-w-[640px] mx-auto leading-relaxed mb-10">
            一级免费网站免费资源汇聚平台，为您提供海量免费网站资源、免费工具、免费素材一站式获取。
            无需注册，无需付费，直接访问最全面的免费内容导航。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/categories"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white rounded-xl text-sm font-semibold transition-all duration-200 whitespace-nowrap"
            >
              浏览全部资源
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/articles"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm hover:bg-background-50/25 text-background-50 rounded-xl text-sm font-semibold transition-all duration-200 border border-background-50/20 whitespace-nowrap"
            >
              阅读精选文章
              <i className="ri-article-line ml-2"></i>
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-12 flex-wrap">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">500+</div>
              <div className="text-background-300/80 text-xs mt-1">精选资源</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">12</div>
              <div className="text-background-300/80 text-xs mt-1">资源分类</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">50K+</div>
              <div className="text-background-300/80 text-xs mt-1">月访问用户</div>
            </div>
            <div className="w-px h-10 bg-background-50/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">100%</div>
              <div className="text-background-300/80 text-xs mt-1">完全免费</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
          <path d="M0 80L60 66.7C120 53.3 240 26.7 360 20C480 13.3 600 26.7 720 33.3C840 40 960 40 1080 33.3C1200 26.7 1320 13.3 1380 6.7L1440 0V80H1380C1320 80 1200 80 1080 80C960 80 840 80 720 80C600 80 480 80 360 80C240 80 120 80 60 80H0Z" fill="oklch(var(--background-50))"/>
        </svg>
      </div>
    </section>
  );
}